module.exports = __webpack_public_path__ + "static/media/closeModalIcon.e0ba23fc.svg";